module.exports = __webpack_public_path__ + "img/img_helper_empty_default.b65182d6.svg";